<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12.0057"
      cy="12.005"
      r="9.00375"
      :stroke="clr"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7 17V9.35294H9.35294V7H14.6471V11.7059H17V17H12.8824V14.6471H11.1176V17H7ZM7.58824 16.4118H9.35294V14.6471H7.58824V16.4118ZM7.58824 14.0588H9.35294V12.2941H7.58824V14.0588ZM7.58824 11.7059H9.35294V9.94118H7.58824V11.7059ZM9.94118 14.0588H11.7059V12.2941H9.94118V14.0588ZM9.94118 11.7059H11.7059V9.94118H9.94118V11.7059ZM9.94118 9.35294H11.7059V7.58824H9.94118V9.35294ZM12.2941 14.0588H14.0588V12.2941H12.2941V14.0588ZM12.2941 11.7059H14.0588V9.94118H12.2941V11.7059ZM12.2941 9.35294H14.0588V7.58824H12.2941V9.35294ZM14.6471 16.4118H16.4118V14.6471H14.6471V16.4118ZM14.6471 14.0588H16.4118V12.2941H14.6471V14.0588Z"
      :fill="clr"
    />
  </svg>
</template>

<script>
export default {
  props: {
    clr: {
      default: "#500FE9"
    }
  }
};
</script>
